// Global double-submit / double-click guard.
//
// Historically only ~8 of ~200 forms & action links set data-disable-with
// by hand, so the same button could be activated twice (e.g. creating two
// reworks). Instead of touching every view, we tag the relevant element
// with an empty `data-disable` just before jquery_ujs's own (bubbling)
// handlers run. jquery_ujs owns the disable/re-enable lifecycle for remote
// forms and links (re-enabling on `ajax:complete`). For non-remote forms whose
// submit is intercepted by JS (e.g. orders filter → bootstrap-table refresh),
// jquery_ujs never fires `ajax:complete`, so we fall back to a 1 s timeout: if
// the element is still disabled when it fires we re-enable it; if jquery_ujs
// already did so the check is a no-op. An empty `data-disable` (vs
// `data-disable-with`) leaves the label/markup untouched.
//
// Capture phase is used so this also covers DOM inserted later (AJAX
// modals, cocoon nested forms).
//
// Opt out by putting `data-no-disable` on the element or any ancestor.

const SUBMIT_BUTTONS = 'input[type=submit], button[type=submit], button:not([type])';
const ACTION_LINK = 'a[data-method], a[data-remote]';

function tag(el) {
  if (!el || el.matches('[data-disable], [data-disable-with]')) return;
  if (el.closest('[data-no-disable]')) return;
  el.setAttribute('data-disable', '');
  setTimeout(() => {
    if (el.disabled) {
      el.disabled = false;
      el.removeAttribute('data-disable');
    }
  }, 1000);
}

document.addEventListener('submit', (e) => {
  const form = e.target;
  if (!form?.matches?.('form') || form.matches('[data-no-disable]')) return;
  form.querySelectorAll(SUBMIT_BUTTONS).forEach(tag);
}, true);

document.addEventListener('click', (e) => {
  tag(e.target?.closest?.(ACTION_LINK));
}, true);
